<div data-testid="charge-category-create-container">
  @if (serverCategoryForm) {
    <form
      [formGroup]="serverCategoryForm"
      (ngSubmit)="updateServiceCategory()"
      data-testid="charge-category-form"
    >
      <!-- Header -->
      <div
        class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300 -mt-3"
        data-testid="charge-category-header"
      >
        <h2 class="mb-0 text-sm" data-testid="charge-category-title">
          {{
            activeCategory()
              ? ('ADMIN.CHARGE.EDIT_CHARGE_CATEGORY' | translate)
              : ('ADMIN.CHARGE.CREATE_CHARGE_CATEGORY' | translate)
          }}
        </h2>
        <div
          class="fa fa-times text-xl text-600 cursor-pointer"
          (click)="categoryCancel()"
          aria-label="close-charge-category-create-dialog-button"
          data-testid="close-charge-category-create-dialog-button"
        ></div>
      </div>
      <!-- Header -->
      <!-- Content -->
      <div
        class="surface-100 p-3 text-sm"
        data-testid="charge-category-content"
      >
        <!-- Service Category Name (English) -->
        <div class="mb-1">
          <label
            class="text-sm mb-2 block"
            data-testid="charge-category-name-primary-label"
          >
            {{ 'ADMIN.CHARGE.CHARGE_CATEGORY_NAME' | translate }}
            @if (isSecondaryLanguage) {
              <span>({{ primaryLanguage | translate }}) </span>
            }
          </label>
          <input
            formControlName="name_primary_language"
            type="text"
            pInputText
            class="w-full text-sm"
            placeholder=""
            value="Personal Training"
            aria-label="charge-category-name-primary-input"
            data-testid="charge-category-name-primary-input"
          />
        </div>
        @if (NamePrimary?.touched) {
          <app-error-msg
            [errors]="NamePrimary?.errors"
            [fieldLabel]="'ADMIN.CHARGE.CHARGE_CATEGORY_NAME' | translate"
            data-testid="charge-category-name-primary-error"
          />
        }
        <!-- Service Category Name (English) -->
        <!-- Service Category Name (French) -->
        @if (isSecondaryLanguage) {
          <div class="mb-1">
            <label
              class="text-sm mb-2 block"
              data-testid="charge-category-name-secondary-label"
            >
              {{ 'ADMIN.CHARGE.CHARGE_CATEGORY_NAME' | translate }} ({{
                secondaryLanguage | translate
              }})</label
            >
            <input
              formControlName="name_secondary_language"
              type="text"
              pInputText
              class="w-full text-sm"
              placeholder=""
              value="Personal Training"
              aria-label="charge-category-name-secondary-input"
              data-testid="charge-category-name-secondary-input"
            />
          </div>
        }
        @if (NameSecondary?.touched) {
          <app-error-msg
            [errors]="NameSecondary?.errors"
            [fieldLabel]="'ADMIN.CHARGE.CHARGE_CATEGORY_NAME' | translate"
            data-testid="charge-category-name-secondary-error"
          />
        }
        <!-- Service Category Name (French) -->
        <!-- Service Category Description (English) -->
        <div class="mb-1">
          <label
            class="text-sm mb-2 block"
            data-testid="charge-category-description-primary-label"
          >
            {{ 'ADMIN.CHARGE.CHARGE_CATEGORY_DESCRIPTION' | translate }}
            @if (isSecondaryLanguage) {
              <span>({{ primaryLanguage | translate }}) </span>
            }
          </label>
          <textarea
            pInputTextarea
            formControlName="description_primary_language"
            class="w-full text-sm"
            aria-label="charge-category-description-primary-input"
            data-testid="charge-category-description-primary-input"
          >
                        {{
              'ADMIN.CHARGE.CHARGE_CATEGORY_DESCRIPTION' | translate
            }}
                        </textarea
          >
        </div>
        @if (DescriptionPrimary?.touched) {
          <app-error-msg
            [errors]="DescriptionPrimary?.errors"
            [fieldLabel]="
              'ADMIN.CHARGE.CHARGE_CATEGORY_DESCRIPTION' | translate
            "
            data-testid="charge-category-description-primary-error"
          />
        }
        <!-- Service Category Description (English) -->
        <!-- Service Category Description (French) -->
        @if (isSecondaryLanguage) {
          <div class="mb-1">
            <label
              class="text-sm mb-2 block"
              data-testid="charge-category-description-secondary-label"
            >
              {{ 'ADMIN.CHARGE.CHARGE_CATEGORY_DESCRIPTION' | translate }} ({{
                secondaryLanguage | translate
              }})</label
            >
            <textarea
              pInputTextarea
              formControlName="description_secondary_language"
              class="w-full text-sm"
              aria-label="charge-category-description-secondary-input"
              data-testid="charge-category-description-secondary-input"
            >
                              {{
                'ADMIN.CHARGE.CHARGE_CATEGORY_DESCRIPTION' | translate
              }}</textarea
            >
          </div>
        }
        @if (DescriptionSecondary?.touched) {
          <app-error-msg
            [errors]="DescriptionSecondary?.errors"
            [fieldLabel]="
              'ADMIN.CHARGE.CHARGE_CATEGORY_DESCRIPTION' | translate
            "
            data-testid="charge-category-description-secondary-error"
          />
        }
        <!-- Service Category Description (French) -->
      </div>
      <!-- Content -->
      <!-- Footer -->
      <div
        class="p-3 flex justify-content-between align-items-center border-top-1 border-300 -mb-3"
        data-testid="form-actions"
      >
        <button
          pButton
          pRipple
          type="button"
          label="{{ 'ADMIN.COMMON.CANCEL' | translate }}"
          styleClass="text-sm"
          class="p-button-text text-sm"
          (click)="categoryCancel()"
          aria-label="cancel-charge-category-button"
          data-testid="cancel-charge-category-button"
        ></button>
        <button
          pButton
          pRipple
          type="submit"
          label="{{ 'ADMIN.COMMON.SAVE' | translate }}"
          class="text-sm"
          aria-label="save-charge-category-button"
          data-testid="save-charge-category-button"
        ></button>
      </div>
      <!-- Footer -->
    </form>
  }
</div>
